import { useI18n } from '../i18n';

export default function LanguageSelector() {
    const { language, setLanguage, languages } = useI18n();

    return (
        <div className="relative group">
            <button
                className="flex items-center gap-2 px-2 sm:px-3 py-2 rounded-lg bg-dark-800 hover:bg-dark-700 transition-colors text-dark-200"
                title={languages.find(l => l.code === language)?.nativeName}
            >
                <span>🌐</span>
                <span className="text-sm hidden sm:inline">
                    {languages.find(l => l.code === language)?.nativeName}
                </span>
            </button>

            <div className="absolute right-0 top-full mt-1 py-1 bg-dark-800 rounded-lg border border-dark-700 shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50 min-w-[140px]">
                {languages.map((lang) => (
                    <button
                        key={lang.code}
                        onClick={() => setLanguage(lang.code)}
                        className={`w-full px-4 py-2 text-left text-sm hover:bg-dark-700 transition-colors ${language === lang.code ? 'text-accent-400' : 'text-dark-200'
                            }`}
                    >
                        {lang.nativeName}
                    </button>
                ))}
            </div>
        </div>
    );
}
